// eslint-disable-next-line func-names
const convertImgToDataURLviaCanvas = function (url, outputFormat) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = () => {
      let canvas = document.createElement('CANVAS');
      const ctx = canvas.getContext('2d');
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL(outputFormat));
      canvas = null;
    };
    img.onerror = reject;
    img.src = url;
  });
};

const headerFooterPDF = async ({ date, time, title, subTitle }, pageOrientation = 'portrait') => {
  const imagem = require('@/assets/imagens/logo somente brasao.png');
  const imagemLivro = require('@/assets/imagens/pasta.png');
  

  const baseImage64Url = await convertImgToDataURLviaCanvas(imagem);
  const livroBaseImage64Url = await convertImgToDataURLviaCanvas(imagemLivro);

  return {
    pageOrientation,
    pageMargins: [20, ((pageOrientation === 'portrait') ? 95 : 85), 20, 45],
    pageSize: 'A4',
    info: {
      title: `${title}/${subTitle} - ${date} ${time}`,
      subject: `${subTitle}`,
    },
    header(currentPage, pageCount) {
      return {
        margin: [20, 20, 20, 0],
        fontSize: 11,        
        table: {
          widths: ['20%','60%', '20%'],           
          body: [
            [
              [
                {
                  image: baseImage64Url,
                  height: 40,
                  width: 55,
                  alignment: 'center',                   
                },
                {
                  text: 'Prefeitura Municipal de Ipatinga',
                  alignment: 'center',
                  fontSize: 9, 
                },
              ],    
             
              
              [   
                                
                { 
                  alignment: 'center',                  
                  columnGap: 5,                 
                  columns: [
                      {                      
                          image: livroBaseImage64Url,                         
                          fit:[15,15],
                          alignment: 'right',  
                          margin: [((pageOrientation === 'portrait') ? 0 : 0), ((pageOrientation === 'portrait') ? 14 : 10), 0, 0],                          
                          width: ((pageOrientation === 'portrait')? '35%' : '40%'),                
                      },
                      {
                        alignment: 'left',
                        text: title,
                        margin: [((pageOrientation === 'portrait') ? 0 : 0), ((pageOrientation === 'portrait') ? 11 : 7), 0, 0],
                        bold: true,
                        fontSize: 13,   
                        width: ((pageOrientation === 'portrait')? '35%' : '50%'),                         
                      }

                  ],
                  
                  
                },
                  
                 
                {
                  alignment: 'center',
                  text: subTitle,
                  margin: [0, 6, 0, 0],
                  bold: true,
                  fontSize: 13,               
                },
              ],
              [
                {
                  fontSize: 9, 
                  margin: [25, ((pageOrientation === 'portrait') ? 9 : 7), 8, 0],
                  columns: [
                    { text: 'Data: ', bold: true, width: '30%' },
                    { text: date, alignment: 'right', width: '75%' },
                  ],
                },
                {
                  fontSize: 9,  
                  margin: [25, 4, 8, 0],
                  columns: [
                    { text: 'Hora: ', bold: true, width: '50%' },
                    { text: time, alignment: 'right', width: '55%' },
                  ],
                },
                {
                  fontSize: 9,   
                  margin: [25, 4, 8, 0],
                  columns: [
                    { text: 'Página: ', bold: true, width: '50%' },
                    { text: `${currentPage.toString()} de ${pageCount}`, alignment: 'right', width: '55%' },
                  ],
                },
              ],
            ],
          ],
        },
      };
    },
    footer: {
      margin: [20, 10, 20, 0],
      fontSize: 9,
      columns: [
        {
          text: 'SIGED  - Sistema de Gestão Educacional',
          italics: true,
        },
        {
          alignment: 'right',
          text: 'Secretaria Municipal de Educação',
          italics: true,
        },
      ],
    },
  };
};

export default headerFooterPDF;
